import i18next from 'i18next';
import { __DEBUG__, DEFAULT_LANGUAGE } from '../constants';

import nl from './locales/nl.json';
import en from './locales/en.json';
import countries_nl from './locales/countries_nl.json'
import countries_en from './locales/countries_en.json'

i18next.init({
  ns: ['translation', 'countries'],
  defaultNS: 'translation',
  fallbackLng: DEFAULT_LANGUAGE,
  fallbackNS: ['translation'],
  resources: {
    nl: {
      translation: nl,
      countries: countries_nl,
    },
    en: {
      translation: en,
      countries: countries_en,
    }
  },
  parseMissingKeyHandler: (missing, fallback) => {
    if (__DEBUG__) {
      console.warn('MISSING TRANSLATION:', missing);
    }
    return fallback || missing;
  },
});

i18next.languages = ['nl', 'en'];

export default i18next;
